


















































































































import {Vue, Component} from 'vue-property-decorator';
import Footers from '@/components/Footers.vue';
import {GetAdminsTempServiceRequest} from 'supporter';
import Logo from '@/components/common/Logo.vue';
@Component({
  components: { Logo, Footers}
})
export default class AgreeTermsForm extends Vue {
  private checked: boolean = false;
  private tempCode = this.$route.query.tempCode;
  private serviceName = '';
  private status: boolean = false;

  private mounted() {
    this.checkStatus();
  }
  private destroyed() {
    $('#container').removeClass('layout_error');
    $('body').removeClass('error_page');
  }
  private isFormPassed() {
    if (!this.checked) {
      alert(window.$t('ADMIN_SERVICE_ALERT_CHECK'));
      return false;
    }
    return true;
  }
  private onClickNextButton() {
    if (this.isFormPassed()) {
      if (this.tempCode) {
        location.href = `/admin/service/registerForm?tempCode=${this.tempCode}`;
      }
    }
  }
  private back2Main() {
    this.$router.replace('/')
  }
  private checkStatus() {
    let request = {
      params: {
        tempCode: this.tempCode as string
      }
    };
    this.$api.getAdminsTempService(request as GetAdminsTempServiceRequest).then(ret => {
      const status = ret.data.adminStatus;
      this.serviceName = ret.data.serviceName
      if (status === ('DELETE')) {
        document.close();
        alert(window.$t('ADMIN_SERVICE_ALREADY_DELETE'));
        location.href = '/login';
      }
      if (status === 'ACTIVE') {
        document.close();
        alert(window.$t('ADMIN_SERVICE_JOINED'));
        location.href = '/login';
      }
    })
    .catch(() => {
      $('#container').removeClass('layout_agreeTerms');
      $('#container').addClass('layout_error');
      $('body').addClass('error_page');
      this.status = true;
    });
  }
}
